import { render, staticRenderFns } from "./TradeRequestDirect.vue?vue&type=template&id=a777db2c"
import script from "./TradeRequestDirect.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports